import { InjectionToken } from '@angular/core';

export const TABS_CONFIG = new InjectionToken<any>('TabsConfig');
